.owl {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  /* Hard "sticker" shadow, owl-shaped — drop-shadow follows the masked silhouette (box-shadow would be
     a rectangle). On the outer wrapper so the mask on .owl__stack doesn't clip the shadow away. Matches
     the bold cards' 6px 6px 0 offset. */
  filter: drop-shadow(6px 6px 0 var(--color-primary-grey-900)); /* PRIMARY_GREY_900 */
}

/* The portrait stack, clipped to the owl-head silhouette (mask set per-instance via --owl-mask). */
.owl__stack {
  position: absolute;
  inset: 0;
  -webkit-mask: var(--owl-mask) center / contain no-repeat;
  mask: var(--owl-mask) center / contain no-repeat;
}

.owl__img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.9s ease;
}

/* 2px ink border tracing the owl silhouette — the same path as the mask, stroked (a CSS border would
   be a rectangle). Sits on top of the photos and matches the bold cards' 2px solid border. */
.owl__border {
  position: absolute;
  inset: 0;
  background: var(--owl-border) center / contain no-repeat;
  pointer-events: none;
}
